const BLANK_RESPUESTAS = ["", "", "", ""];

/**
 * @param {unknown} q
 * @returns {boolean}
 */
export function isBlankTestPregunta(q) {
  if (!q || typeof q !== "object") {
    return true;
  }
  const enunciado = (q.pregunta ?? "").trim();
  const imagenUrl = (q.imagenUrl ?? "").trim();
  const explicacion = (q.explicacion ?? "").trim();
  if (enunciado !== "" || imagenUrl !== "" || explicacion !== "") {
    return false;
  }
  const respuestas = Array.isArray(q.respuestas) ? q.respuestas : [];
  const hasAnswerText = respuestas.some((r) => (r ?? "").trim() !== "");
  if (hasAnswerText) {
    return false;
  }
  return q.correcta === null || q.correcta === undefined;
}

/**
 * @param {unknown} items
 * @returns {Array<Record<string, unknown>>}
 */
export function filterNonBlankTestPreguntas(items) {
  if (!Array.isArray(items)) {
    return [];
  }
  return items.filter((q) => !isBlankTestPregunta(q));
}

/**
 * @param {unknown} items
 * @param {{ allowDraft?: boolean }} [options]
 * @returns {string | null}
 */
export function validateTestPreguntasForSave(items, options = {}) {
  const { allowDraft = false } = options;
  const list = allowDraft ? filterNonBlankTestPreguntas(items) : items;
  if (!Array.isArray(list) || list.length === 0) {
    if (allowDraft) {
      return null;
    }
    return "⚠️ El test debe tener al menos una pregunta con contenido.";
  }
  for (let i = 0; i < list.length; i += 1) {
    const q = list[i];
    const enunciado = (q?.pregunta ?? "").trim();
    const imagenUrl = (q?.imagenUrl ?? "").trim();
    if (enunciado === "" && imagenUrl === "") {
      return `⚠️ La pregunta ${i + 1} necesita un enunciado o una imagen.`;
    }
    const respuestas = Array.isArray(q?.respuestas) ? q.respuestas : [];
    const nonEmptyCount = respuestas.reduce((n, r) => n + ((r ?? "").trim() !== "" ? 1 : 0), 0);
    if (nonEmptyCount < 2) {
      return `⚠️ La pregunta ${i + 1} debe tener al menos dos respuestas con texto.`;
    }
    const { correcta } = q;
    if (correcta === null || correcta === undefined || typeof correcta !== "number" || !Number.isInteger(correcta)) {
      return `⚠️ La pregunta ${i + 1}: marca cuál es la respuesta correcta.`;
    }
    if (correcta < 0 || correcta >= respuestas.length) {
      return `⚠️ La pregunta ${i + 1}: la respuesta correcta no es válida.`;
    }
    if ((respuestas[correcta] ?? "").trim() === "") {
      return `⚠️ La pregunta ${i + 1}: la respuesta marcada como correcta no puede estar vacía.`;
    }
  }
  return null;
}

export { BLANK_RESPUESTAS };
